import { render, staticRenderFns } from "./UserInfo.vue?vue&type=template&id=e2683b9e&scoped=true&"
import script from "./UserInfo.vue?vue&type=script&setup=true&lang=ts&"
export * from "./UserInfo.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./UserInfo.vue?vue&type=style&index=0&id=e2683b9e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2683b9e",
  null
  
)

export default component.exports